<template>
    <div>
        <h1 class="text-muted text-center" v-if="categories.length<=0">هیچ دسته‌بندی وجود ندارد</h1>
        <ul style="list-style: none" class="my-5" v-else>
            <recursive-component v-if="breadCrumb.length > 0" :bread-crumb="breadCrumb"
                                 :data-back="backward"></recursive-component>
            <li style="font-size: 11.5pt;"
                @click="parent_id=item.id;breadCrumb.push(item)"
                class="cursor-pointer py-2 px-5"
                v-for="item in categories.filter((x)=>x.parent_id===parent_id)"
            ><img :src="item.icon" class="img-fluid" alt="" width="30" height="30" style="border: none">
                {{ item.title }}
                <i class="fa fa-chevron-left float-left mr-auto my-2" style="color: #3F51B5"></i>
            </li>
        </ul>
    </div>
</template>

<script>
import Amqezi from "./recursiveComponent";
import RecursiveComponent from "./recursiveComponent";
import {Axios2, Bus} from "../../../main";

export default {
    name: "renderCategory",
    components: {
        Amqezi,
        RecursiveComponent
    },
    data() {
        return {
            categories: [],
            parent_id: null,
            breadCrumb: [],
        }
    },
    methods:{
        getCategory() {
            Axios2.get('/admin/category').then((response) => {
                this.categories = response.data.data;
            })
        },
        backward(item) {
            const index = this.breadCrumb.indexOf(item);

            this.parent_id = item.parent_id;

            this.breadCrumb.splice(index, this.breadCrumb.length);
        },
    },
    created(){
        this.getCategory();
    },
    watch:{
        parent_id: {
            handler(value){
                Bus.$emit('getCategoryId', value);
            },
            deep:true
        }
    }
}
</script>

<style scoped>

</style>